<template>
    <div v-if="vehicule" class="w-100">
        <label class="label-calculators" :class="{'plane-adjustment':plane}"><img :src="vehicule.icon" class="mobile-distance-calculator-icon"/>{{ vehicule.type }}</label>
        <div class="row vertical-center space-between">
            <div class="col-20">
                <img :src="vehicule.icon" class="distance-calculator-icon"/>
            </div>
            <div class="position-relative " :class="{'col-33':plane, 'col-25':!plane}">
                <input type="number" class="distance-calculator-input w-100" placeholder="À l'aller" v-model="results['aller']" @input="$emit('update:modelValue', results)" min="0"/>
                <div class="km">km</div>
            </div>
            <div class="position-relative" :class="{'col-33':plane,'col-25':!plane}">
                <input type="number" class="distance-calculator-input w-100" placeholder="Au retour" v-model="results['retour']" @input="$emit('update:modelValue', results)" min="0"/>
                <div class="km">km</div>
            </div>
            <div class="position-relative" v-if="!plane" :class="{'col-33':plane, 'col-25':!plane}">
                <input type="number" class="distance-calculator-input w-100" placeholder="À Trois-Rivières" v-model="results['troisRivieres']" @input="$emit('update:modelValue', results)" min="0"/>
                <div class="km">km</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            results:{
                aller:null,
                retour:null,
                troisRivieres:null
                
            },
            width:screen.width
        }
    },
    props: {
        vehicule: Object,
        plane:{type:Boolean, default:false},
        modelValue: Object
    },
    
    watch: {
    modelValue(newVal) {
      this.results = newVal;
    }
  },
  mounted(){
    this.results.factor = this.vehicule.factor
  }
}
</script>
<style scoped>
.label-calculators{
    color: var(--color);
    font-family: var(--font);
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: 33.2px;
}
.distance-calculator-icon{
    width: 90%;
    margin-left:5%;
    margin-right: 5%;
}
.distance-calculator-input {
    display: flex;
    height: 57px;
    padding-left: 12px;
    padding-right: 40px;
    padding-top: 12px;
    padding-bottom: 12px;
    margin-right: 10px;
    border: 2px solid var(--Secondary-Noir, #3B3B3C);
    box-shadow: 4px 4px 24px 0px rgba(0, 0, 0, 0.15);
    text-align: end;
    box-sizing:border-box;
}
.distance-calculator-input::placeholder{
    color: #bab1b1;
    font-family: var(--font);
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 28.2px; /* 235% */
}
.km {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: var(--text-color);
    font-family: var(--font);
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 28.2px;
    /* 141% */
}
.col-20{
    width:20%;
}
.col-25{
    width:25%;
}
.col-33{
    width:33%;
}
.mobile-distance-calculator-icon{
    display: none;
}
@media screen and (max-width: 1500px) {
  .label-calculators{
    font-size: 28px;
  }
}
@media screen and (max-width: 1300px) {
    .label-calculators{
        font-size: 23px;
    }
}
@media screen and (max-width: 900px) {
    .col-25{
        width:90%;
        margin-top:10px;
        
    }
    .col-33{
        width:90%;
        margin-top:10px;
        
    }
    .distance-calculator-icon{
        display: none;
    }
    .mobile-distance-calculator-icon{
        width:60px;
        display:block;
    }
    .label-calculators{
        margin-top:10px;
        display: flex;
        align-items: center;
    }
    .plane-adjustment{
      margin-bottom:9px;
    }
}
@media screen and (max-width: 750px) {
    .col-25{
        width:100%;
        margin-top:10px;
        
    }
    .col-33{
        width:100%;
        margin-top:10px;   
    }
    .plane-adjustment{
      margin-bottom:0;
    }

}
@media screen and (max-width: 600px) {
.label-calculators{
    font-size: 20px;
  }
  .distance-calculator-input::placeholder{
    font-size:10px;
  }
  .km{
    font-size:12px;
    right: 5px;
  }
  .distance-calculator-input {
    padding-left: 5px;
    padding-right: 20px;
  }
}
</style>